// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15cYL","newExpiryDate":"styles_newExpiryDate__xaNxn","footer":"styles_footer__7ybyS"};